import { Box, Text, Group } from '@mantine/core';
import { IconMessages } from '@tabler/icons-react';
import { ConversaPanel } from '@/components/Conversa';

interface ConversaSidebarProps {
  onSendChatMessage: (text: string) => void;
  isOwner: boolean;
  isTranscribing: boolean;
  onStartTranscription: () => void;
  onStopTranscription: () => void;
}

export const ConversaSidebar = ({
  onSendChatMessage,
  isOwner,
  isTranscribing,
  onStartTranscription,
  onStopTranscription,
}: ConversaSidebarProps) => {
  return (
    <Box
      style={{
        width: 320,
        backgroundColor: 'white',
        borderRight: '1px solid #e9ecef',
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
      }}
    >
      {/* Header */}
      <Box
        style={{
          padding: '12px 16px',
          borderBottom: '1px solid #e9ecef',
          backgroundColor: '#f8f9fa',
        }}
      >
        <Group gap="xs">
          <IconMessages size={18} color="#228be6" />
          <Text fw={600} size="sm">
            Conversa
          </Text>
        </Group>
      </Box>

      {/* Content */}
      <Box style={{ flex: 1, minHeight: 0, overflow: 'hidden' }}>
        <ConversaPanel
          onSendChatMessage={onSendChatMessage}
          isOwner={isOwner}
          isTranscribing={isTranscribing}
          onStartTranscription={onStartTranscription}
          onStopTranscription={onStopTranscription}
        />
      </Box>
    </Box>
  );
};
